// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3n-1";
export var rateTableServiceLevelDropdown = "_3n-3";
export var rateTableTypeDropdown = "_3n-0";
export var rateTableValueModeDropdown = "_3n-2";